import clsx from "clsx";
import { ReactElement } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { ColumnMapping, CSVUploadFormData } from "../types/form-inputs";
import { Heading } from "./catalyst/Heading";
import { Text } from "./catalyst/Text";
import EntitySelectField from "./inputs/EntitySelectField";
import SelectFieldGroup from "./inputs/SelectFieldGroup";

export const CSVColumnMapper = (): ReactElement => {
  const {
    control,
    formState: { errors },
    register,
    watch,
  } = useFormContext<CSVUploadFormData>();

  const { fields: columnMappings } = useFieldArray({
    control,
    name: "columnsMappings",
  });

  return (
    <div className="space-y-6">
      <div>
        <Heading level={3}>Map CSV Columns</Heading>
        <Text className="text-sm text-zinc-600 dark:text-zinc-400">
          Map CSV columns to entity types. Only entity columns will be imported.
        </Text>
      </div>

      <div className="space-y-4">
        {columnMappings.map((header: ColumnMapping, index: number) => {
          const ignoreValue = watch(`columnsMappings.${index}.ignore`);
          const shouldShowEntitySelect = ignoreValue === "false";

          return (
            <div className="space-y-2" key={index}>
              <div className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
                Column: {header.name}
              </div>
              <div
                className={clsx(
                  "grid gap-3",
                  shouldShowEntitySelect ? "grid-cols-2" : "grid-cols-1",
                )}
              >
                <SelectFieldGroup
                  errors={errors}
                  fieldName={`columnsMappings.${index}.ignore`}
                  options={[
                    { label: "Ignore", value: "true" },
                    { label: "Entity Type", value: "false" },
                  ]}
                  register={register}
                  rules={{
                    required: "Field is required",
                  }}
                />

                {shouldShowEntitySelect && (
                  <EntitySelectField
                    control={control}
                    errors={errors}
                    fieldName={`columnsMappings.${index}.entityId`}
                    placeHolder="Enter entity"
                    rules={{
                      required: "Entity type is required",
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
